import { ReactNode } from 'react';

import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import useAutoSelectValue from '../util/use-auto-select-value';

export interface BaseSelectFilterProps<T> {
  label?: string;
  autoSelectIfEmpty?: boolean;
  value: T;
  onChange: (value: T) => void;
  options: { id: string; label: string; value?: number | string }[];
  error?: boolean;
  helperText?: ReactNode;
}

export function BaseSelectFilter<T>({
  label,
  value,
  autoSelectIfEmpty = false,
  onChange,
  options,
  error,
  helperText,
}: BaseSelectFilterProps<T>) {
  useAutoSelectValue({
    value,
    options: options as any,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess: true,
  });
  const handleChange = useTransformSelectValue(onChange);
  return (
    <Select
      label={label || ''}
      fullWidth
      size="small"
      value={value}
      options={options}
      onChange={handleChange}
      error={error}
      helperText={helperText}
    />
  );
}
